import { Video as LucideIcon } from "lucide-react";
import { Shield, ArrowRight, Lock } from "lucide-react";
import {
  Eye,
  Server,
  CheckCircle,
  Users,
  Zap,
  Globe,
  CheckCircle2,
  Headphones,
  BarChart3,
} from "lucide-react";
import { useState } from "react";
import modal from "../../images/modal.png";
import data from "../../images/data_manage.webp";
import { GrDocumentConfig } from "react-icons/gr";
import { FaRegLightbulb } from "react-icons/fa";
import { VscDebugDisconnect } from "react-icons/vsc";
import { AiOutlineAudit } from "react-icons/ai";
import { TfiEmail } from "react-icons/tfi";
import { TbDatabaseEdit } from "react-icons/tb";
import { TbReportAnalytics } from "react-icons/tb";
import { CiMobile1 } from "react-icons/ci";
import emailjs from "@emailjs/browser";

const GRC = () => {
  const features = [
    {
      icon: GrDocumentConfig,
      title: "Framework Integration",
      description:
        "Easily onboard global security and privacy standards such as ISO 27001, NIST CSF, GDPR, SOC 2, and PCI-DSS. MCRS allows seamless import and management of these frameworks to build your compliance foundation.",
    },
    {
      icon: GrDocumentConfig,
      title: "Risk Register & Treatment Tracker",
      description:
        "Maintain a live inventory of organizational risks. Score risks based on likelihood and impact, assign mitigation actions, and monitor treatment progres.",
    },
    {
      icon: FaRegLightbulb,
      title: "Control & Implementation Mapping",
      description:
        "Define organizational controls and link them directly to specific compliance requirements and real-world implementations for full traceability.",
    },
    {
      icon: Shield,
      title: "Real-Time Dashboards",
      description:
        "Visualize your compliance posture, audit progress, control effectiveness, and risk exposure using dynamic, role-specific dashboards.",
    },
    {
      icon: VscDebugDisconnect,
      title: "Audit Management Engine",
      description:
        "Plan, assign, and track internal and external audits. Record findings, upload evidence, and generate audit-ready reports with a single click.",
    },
    {
      icon: AiOutlineAudit,
      title: "Report Generation",
      description:
        "nstantly create clean, professional reports for stakeholders, auditors, and leadership teams in PDF or Excel formats.",
    },
  ];
  const Values = [
    {
      icon: GrDocumentConfig,
      title: "Fast Deployment,Minimal Training",
      description:
        "MCRS is designed with usability in mind, allowing teams to onboard and go live quickly — without extensive training or technical overhead..",
    },
    {
      icon: GrDocumentConfig,
      title: "Real-Time Risk & Compliance Visibility",
      description:
        "Executive dashboards provide a consolidated view of your compliance health, control effectiveness, and risk exposure at any moment.",
    },
    {
      icon: FaRegLightbulb,
      title: "Audit Readiness at Your Fingertips",
      description:
        "Automatically generate well-structured, evidence-backed reports tailored for internal or external udits",
    },
    {
      icon: Shield,
      title: "Proactive Risk Management",
      description:
        "Identify, score, and treat risks before they escalate. Gain full control over the risk lifecycle and link risks to controls and business units.",
    },
    {
      icon: VscDebugDisconnect,
      title: "Enables Continuous Improvement",
      description:
        "Close feedback loops between audits, control reviews, and implementations to create a culture of continuous compliance.",
    },
    {
      icon: AiOutlineAudit,
      title: "Enterprise-Grade Security",
      description:
        "Role-based access, full audit logs, and secure deployment options ensure that your sensitive compliance data stays protected.",
    },
  ];
  const [loading,setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    phone: "",
    password: "",
    textarea: "",
    company: "",
    organization : "",
    agree: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState("");

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: formData.fullname,
      email: formData.email,
      subject: "Request for Maplecloud RISK-SUITE Product Demo",
      phone  : formData.phone,
      message: formData.textarea,
    };

    try {
      const response = await fetch(`https://backend.maplecloudtechnologies.com:7443/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        alert("✅ " + data.message);
        setContactForm(false);
        setFormData({
          fullname: "",
          email: "",
          phone: "",
          password: "",
          textarea: "",
          company: "",
          agree: false,
        });
      } else {
        alert("❌ " + (data.error || "Failed to submit support request."));
      }
    } catch (err) {
      console.error("Error:", err);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };

   const handleTrial = async (e) => {
    e.preventDefault();
  setLoading(true)
    const payload = {
       name: formData.fullname,
      email: formData.email,
      subject: "Request for Maplecloud RISK-SUITE Trial",
      phone  : formData.phone,
      organization : formData.organization,
      message: formData.textarea,
      
    };

    try {
      const response = await fetch(`https://backend.maplecloudtechnologies.com:7443/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
          setLoading(false)
        alert("✅ " + data.message);
        setTrialForm(false);
        setFormData({
          fullname: "",
          email: "",
          phone: "",
          password: "",
          textarea: "",
          company: "",
          organization :"",
          agree: false,
        });
      } else {
          setLoading(false)
        alert("❌ " + (data.error || "Failed to submit support request."));
      }
    } catch (err) {
        setLoading(false)
      console.error("Error:", err);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };

  const [contactForm, setContactForm] = useState(false);
  const [trialForm, setTrialForm] = useState(false);
    const [users,setUsers] = useState('')
  
  return (
    <>
      {trialForm && (
        <div className="flex fixed w-full  items-center justify-center min-h-screen bg-gray-900/80 backdrop-blur-sm z-20 p-4">
          <div className="w-full max-w-md bg-slate-950 text-white p-8 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-2xl font-medium mb-6">
              Contact Us for a free trial            </h1>
            <p className="text-gray-400 text-sm mb-6">
              Fill out the form below and our team will get in touch with you
              for a free trial.
            </p>
            <form onSubmit={(e) => {
              handleTrial(e); setUsers('')
            }} className="space-y-5">
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Your name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    placeholder="Message..."
                    required
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {errors && <p className="text-red-600 text-sm">{errors}</p>}

              <div className="w-full flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setTrialForm(false);
                    setFormData({
                      fullname: "",
                      email: "",
                      phone: "",
                      password: "",
                      textarea: "",
                      company: "",
                      agree: false,
                    });
                  }}
                  className="w-full bg-slate-600 text-white py-2 rounded-lg font-semibold hover:bg-pink-700 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-full bg-pink-600 text-white py-2 rounded-lg font-semibold hover:bg-pink-700 transition"
                >
                  Request Trial
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
        {contactForm && (
        <div className="flex fixed w-full  items-center justify-center min-h-screen bg-gray-900/80 backdrop-blur-sm z-20 p-4">
          <div className="w-full max-w-md bg-slate-950 text-white p-8 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-2xl font-medium mb-6">
              Contact Us for a Product Demo
            </h1>
            <p className="text-gray-400 text-sm mb-6">
              Fill out the form below and our team will get in touch with you
              for a personalized demo.
            </p>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Your full name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    placeholder="Message..."
                    required
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {errors && <p className="text-red-600 text-sm">{errors}</p>}

              <div className="w-full flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setContactForm(false);
                    setFormData({
                      fullname: "",
                      email: "",
                      phone: "",
                      password: "",
                      textarea: "",
                      company: "",
                      agree: false,
                    });
                  }}
                  className="w-full bg-slate-600 text-white py-2 rounded-lg font-semibold hover:bg-pink-700 transition"
                >
                    Cancel
                </button>
                <button
                  type="submit"
                  className="w-full bg-pink-600 text-white py-2 rounded-lg font-semibold hover:bg-pink-700 transition"
                >
                  Request Demo
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <section className="relative overflow-hidden pt-20 pb-10 px-4 sm:px-6 lg:px-8">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-to-b from-pink-600/10 to-transparent"></div>
        <div className="absolute top-20 left-10 w-56 sm:w-72 h-56 sm:h-72 bg-pink-600/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-5 w-64 sm:w-96 h-64 sm:h-96 bg-pink-600/20 rounded-full blur-3xl"></div>

        {/* Main Container */}
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-12 px-4 sm:px-8 mt-5">
          {/* Left Content */}
          <div className="text-start w-full lg:w-1/2 mt-5">
            <div className="inline-flex items-center gap-2 bg-pink-500/10 border border-pink-500/20 rounded-full px-4 py-2 mb-6">
              <Lock className="w-4 h-4 text-pink-400" />
              <span className="text-sm text-pink-300 font-medium">
                MCT MCRS
              </span>
            </div>

            <h1 className="text-2xl md:text-4xl font-bold text-white mb-6 leading-tight">
              <span className="block text-4xl sm:text-5xl bg-gradient-to-r from-pink-400 to-pink-700 bg-clip-text text-transparent mb-2">
                MAPLECLOUD-RISK SUITE
              </span>
              Enterprise Cyber Governance, Risk & Compliance Platform
            </h1>

            <p className="text-base sm:text-lg text-slate-300 mb-10 leading-relaxed">
              MCRS – MapleCloud Risk Suite is a fully proprietary,
              enterprise-grade Governance, Risk, and Compliance (GRC) platform
              developed by MapleCloud Technologies. It helps organizations
              simplify compliance programs, manage cyber risks proactively, and
              streamline audits — all within a clean, user-friendly interface.
            </p>
          </div>

          {/* Right Side Form */}
          <div className="w-full lg:w-1/2 max-w-md bg-slate-900/40 backdrop-blur-md text-white p-6 sm:p-6 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-xl sm:text-2xl font-medium mb-6 text-center lg:text-left">
             Contact for free trial
            </h1>

            <form  onSubmit={(e) => {
              handleTrial(e); setUsers('')
            }}  className="space-y-3">
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Full name"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
                <div>
                <input
                  id="organization"
                  name="organization"
                  type="text"
                  value={formData.organization}
                  onChange={handleChange}
                  placeholder="Organization name"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    
                    placeholder="Message..."
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {/* Checkbox */}
              <div className="flex items-start gap-2 text-sm">
                <input
                  id="agree"
                  name="agree"
                  type="checkbox"
                  checked={formData.agree}
                  onChange={handleChange}
                  
                  className="mt-1"
                />
                <label htmlFor="agree" className="text-gray-400">
                  I agree to the{" "}
                  <a href="#" className="text-pink-400 hover:underline">
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a href="#" className="text-pink-400 hover:underline">
                    Privacy Policy
                  </a>
                  .
                </label>
              </div>

              {/* Messages */}
              {errors && <p className="text-red-500 text-sm">{errors}</p>}
              {message && <p className="text-green-500 text-sm">{message}</p>}

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-pink-600 text-white py-2 rounded-lg font-semibold hover:bg-pink-700 transition"
              >
              {
                  loading ? 'Sending...' : ' Send Request'
                }
              </button>
            </form>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-pink-500/10 border border-pink-500/20 rounded-full px-4 py-2 mb-6">
              <Globe className="w-4 h-4 text-pink-400" />
              <span className="text-md text-pink-300 font-medium">
                Features
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              KEY FEATURES OF MCRS
            </h2>
            <p className="text-sm text-slate-400 max-w-3xl mx-auto">
              MCRS – MapleCloud Risk Suite offers a powerful set of enterprise
              features designed to bring structure, visibility, and confidence
              to your cybersecurity and compliance programs. Every feature is
              crafted to reduce manual effort, increase traceability, and
              improve audit readiness — all within a user-friendly, secure
              interface.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f) => (
              <div className="bg-slate-900 border border-slate-700 rounded-xl p-8 hover:border-pink-500/50 transition hover:shadow-3xl   hover:shadow-pink-500/10 group">
                <div className="bg-gradient-to-br from-pink-500 to-pink-800 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <f.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-medium text-white mb-3">
                  {f.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-xs">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        id="features"
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col items-center"
      >
        {/* Section Header */}
        <div className="w-[90%] max-w-[350px] flex justify-center text-lg items-center gap-2 bg-pink-500/10 border border-pink-500/20 rounded-full px-4 py-2 mb-10">
          <Globe className="w-6 h-6 text-pink-400" />
          <span className="text-xl text-pink-300 font-medium">
            CORE MODULES OF MCRS
          </span>
        </div>

        {/* Content */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start w-full">
          {/* Left Side - Illustration */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src={modal}
              alt="feature_img"
              className="w-full max-w-md object-contain"
            />
          </div>

          {/* Right Side - Features */}
          <div className="w-full lg:w-1/2 mt-6 lg:mt-0 space-y-6">
            {[
              "STANDARDS MANAGER : Import and manage cybersecurity frameworks like ISO 27001, NIST CSF, GDPR, and more. View requirements in a structured layout and track progress against each standard.",
              "CONTROLS & IMPLEMENTATIONS : Define organizational controls and link them to specific implementation actions. Assign ownership, attach documentation, and monitor implementation status with full traceability.",
              "AUDIT TRACKER : Plan and conduct internal or external audits. Log findings, assign reviewers, collect evidence, and generate detailed audit reports — all from a single interface.",
              "DASHBOARDS & REPORTS : Access real-time dashboards that reflect compliance progress, audit status, and risk exposure. Export reports for management review or audit submission with one click. The strength of MCRS lies in its modular architecture — each module is purpose-built to support a specific aspect of Governance, Risk, and Compliance.",
              "RISK REGISTER : Maintain a centralized inventory of risks. Score risks based on impact and likelihood, assign treatment plans, monitor remediation, and generate risk dashboards.",
            ].map((text, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-pink-600/20 rounded-full flex items-center justify-center text-pink-400">
                  <CheckCircle2 className="w-5 h-5" />
                </div>
                <p className="text-slate-300 text-base sm:text-md leading-relaxed">
                  {text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              BUSINESS VALUE OF MCRS
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Values.map((f) => (
              <div className="bg-slate-900 border border-slate-700 rounded-xl p-8 hover:border-pink-500/50 transition hover:shadow-3xl   hover:shadow-pink-500/10 group">
                <div className="bg-gradient-to-br from-pink-500 to-pink-800 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <f.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-medium text-white mb-3">
                  {f.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-xs">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white py-24 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-pink-600">
              Pricing Plans
            </span>
          </h2>
          <p className="text-slate-400 mb-16 max-w-2xl mx-auto text-lg">
            Transparent and flexible pricing tailored for individuals, startups,
            and enterprises. Upgrade as your business grows.
          </p>
          <div className="grid  md:grid-cols-3">
            <div className="bg-slate-800/60 backdrop-blur-lg rounded-3xl shadow-xl border border-slate-700 p-10  hover:shadow-pink-500/20 transition duration-300">
              <h3 className="text-2xl font-semibold mb-3">Free Trial</h3>
              <div className="text-5xl font-bold mt-6 text-pink-400">
                100<span className="text-xl text-slate-200">Users</span>
              </div>

             
              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => {
                  }}
                  className="w-full bg-white text-pink-700 font-semibold py-3 rounded-xl shadow-md hover:bg-slate-100 transition"
                >
                  Start Trial
                </button>
                <button
                  onClick={() => {
                    setTrialForm(true);
                    setUsers(" for 100 Users");
                  }}
                  className="w-full bg-pink-600 hover:bg-pink-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-pink-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>

            <div className="relative z-10 scale-110 bg-gradient-to-b from-pink-500 to-pink-950 rounded-3xl shadow-2xl p-10  transition duration-300 border border-slate-700">
              <h3 className="text-2xl font-semibold mb-3">Enterprise</h3>
              <div className="text-xl mt-6 font-medium  text-white">
                Contact us for purchase
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => setContactForm(true)}
                  className="w-full bg-pink-600 hover:bg-pink-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-pink-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default GRC;
